<template>
  <div class="z-index__container">
    <div class="z-index__title">{{ $t("ct-layer") }}</div>
    <div class="z-index__options">
      <div class="z-index__option" @click="changeIndex(-1)">
        {{ $t("ct-down") }} <i class="ct-icon-layers z-index__icon-down"></i>
      </div>
      <div class="z-index__option" @click="changeIndex(1)">
        {{ $t("ct-up") }} <i class="ct-icon-layers z-index__icon-up"></i>
      </div>
    </div>
    <div class="z-index__level">{{ $t("ct-layer-level") }} {{ valueDesc }}</div>
  </div>
</template>

<script>

	export default {
		name: 'ZIndexComponent',
		components: {},
		data() {
			return {
				valueDesc : 0,
				callback: null,
			}
		},
		methods: {
			changeIndex(val) {

				if (this.value == 'auto') {
					this.value = 0;
				}

				this.value = val + parseInt(this.value);

				if(this.value < 0){
					this.value = 0;
        }

				this.valueDesc = this.value;
				this.callback(this.value);
			},
			setValues(obj) {
				this.value = obj.defaultValue || 'auto';
				this.valueDesc = this.value;

				this.callback = obj.callback;
			}
		},
	}
</script>



// WEBPACK FOOTER //
// src/components/editor/resource_components/ZIndex.vue